// API Configuration
export const API_CONFIG = {
  BASE_URL: 'https://api.jpnewz.com/dashboard',
  ENDPOINTS: {
    LOGIN: '/login',
    SEND_EMAIL_OTP: '/send_email_forgot_password',
    // Add more endpoints here as needed
    // DASHBOARD: '/dashboard',
    // USERS: '/users',
    // ARTICLES: '/articles',
  }
};

// Helper function to get full API URL
export const getApiUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Helper function to get login URL
export const getLoginUrl = () => {
  return getApiUrl(API_CONFIG.ENDPOINTS.LOGIN);
};

// Helper function to get send email OTP URL
export const getSendEmailOtpUrl = () => {
  return getApiUrl(API_CONFIG.ENDPOINTS.SEND_EMAIL_OTP);
}; 